{
  "status": {
    "loaded": "License loaded",
    "notFound": "Not found or corrupted"
  },
  "label": {
    "status": "License status",
    "requestTitle": "License request"
  },
  "section": {
    "owner": "Owner",
    "licenseInfo": "License Information",
    "licenseUsage": "License Usage"
  },
  "field": {
    "country": "Country of registration",
    "state": "Region of registration",
    "locality": "City of registration",
    "organization": "Organization name",
    "domain": "Pamir server domain name",
    "email": "Organization representative email",
    "type": "Type",
    "expiration": "License expiration date",
    "issueTime": "License issue time",
    "controlledObjects": "Number of controlled objects",
    "allowCis": "Number of CEs"
  },
  "button": {
    "request": "Request license",
    "upload": "Upload license"
  },
  "action": {
    "successSaveMsg": "Uploaded successfully"
  },
  "text": {
    "of": "of",
    "used": "Used",
    "remaining": "Available",
    "exceeded": "Overdraft",
    "controlledObjects": "Controlled Objects",
    "allowCis": "CEs"
  },
  "service": {
    "CMDB": "CMDB",
    "Monitoring": "Monitoring"
  },
  "placeholders": {
    "country": "Select a country",
    "city": "Moscow",
    "type": "standard / professional / temporary",
    "unlimited": "Unlimited",
    "unlimitedPeriod": "Unlimited period",
    "domain": "pamir.int",
    "email": "pamir@int.ru"
  },
  "types": {
    "temporary": "Temporary",
    "standard": "Standard",
    "professional": "Professional"
  }
}